import { useAuthStore } from "@/lib/auth";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/auth/callback")({
	component: AuthCallback,
});

function AuthCallback() {
	const [error, setError] = useState<string>();
	const handleCallback = useAuthStore((s) => s.handleCallback);
	const navigate = useNavigate();
	const called = useRef(false);
	const { t } = useTranslation();

	useEffect(() => {
		if (called.current) return;
		called.current = true;

		const params = new URLSearchParams(window.location.search);
		const code = params.get("code");

		if (!code) {
			setError(t("auth_code_missing"));
			return;
		}

		handleCallback(code)
			.then(() => {
				const returnTo = localStorage.getItem("auth_return_to");
				localStorage.removeItem("auth_return_to");
				window.location.href = returnTo || "/";
			})
			.catch((e) => setError(e instanceof Error ? e.message : t("auth_error")));
	}, [handleCallback, navigate, t]);

	if (error) {
		return (
			<div className="flex min-h-screen items-center justify-center">
				<div className="rounded-lg border border-red-200 bg-red-50 p-6 text-center">
					<p className="text-sm text-red-700">{error}</p>
					<a
						href="/login"
						className="mt-3 inline-block text-sm text-red-600 underline"
					>
						{t("auth_back_to_login")}
					</a>
				</div>
			</div>
		);
	}

	return (
		<div className="flex min-h-screen items-center justify-center">
			<p className="text-sm text-slate-500">{t("auth_logging_in")}</p>
		</div>
	);
}
